<div style="position: relative; z-index: 10;">
  <!-- contenedor de todo el header -->
  <div class="containerNavBar">
    <loading [isFixed]="true" [isLoading]="this.isLoading" [isFullSize]="true"></loading>
    
    <!-- poner *ngIf="isMapix" para que no se muestre en citronella el nav -->
    <mat-toolbar class="fullNav"  id="fullNav" *ngIf="isMapix">
      
      <!-- boton para abrir side-bar -->
      <!-- <div style="width: 3.125vw;">
        <button *ngIf="!mobileQuery.matches" mat-icon-button (click)="EnlargeOrCloseSideBar()" id="sideBarButtonNav">
          <img
          src="../../../../assets/img/navBar/btn_menu_blanco.png"
          style="width: 1.5em;"
          />
        </button>
      </div> -->
      
      <!-- parte superior-->
      <div class="nav-top">
        
        <!-- logo -->
        <div class="nav-left">
          <button *ngIf="!mobileQuery.matches" mat-icon-button (click)="EnlargeOrCloseSideBar()" class="mobile-menu-btn" id="sideBarButtonNav">
            <mat-icon>menu</mat-icon>
          </button>
          <div class="nav-text-appname">
            <img src="../../../../../../assets/img/logo Mapix.svg" class="nav-logo-img"/>
          </div>
        </div>
        
        <div class="nav-options-container">
          
          <div class="nav-right" [@expandCollapseOptions]="this.areOptionsExpanded ? 'visible' : 'hidden'">
            
            <div [ngClass]="{'display-none': !mobileQuery.matches}" class="nav-text-client" id="customerSelectNav">
              <mat-select class="btn-clients"
              [placeholder]="selectedClient?.customerName"
              [(value)]="selectedClient"
              (selectionChange)="onChangeClient($event)"
              [disabled]=" !isMapix " *ngIf="isMapix">
              <mat-select-trigger class="customer-trigger-flex">
                <div class="customer-trigger-logo-container">
                  <img class="customer-trigger-logo" [src]="'../../../../../../assets/img/' + selectedClient?.logo" alt="Imagen" >
                </div>
                <span class="customer-trigger-name">{{ selectedClient?.customerName }}</span>
              </mat-select-trigger>
              <mat-option *ngFor="let client of clientes" [value]="client">
                <div class="customer-option-flex">
                  <span class="customer-option-logo"><img [src]="'../../../../../../assets/img/' + client.logo"></span>
                  <span class="customer-option-name">{{ client.customerName }}</span>
                </div>
              </mat-option>
            </mat-select>
          </div>
          
          <!-- seccion de notificacion -->
          <div class="floating-button-container nav-notification-button" id="notificationsButtonNav" >
            <img class="nav-notification-button" [src]="'icon_notificacion.svg' | findUrl"   (click)="toggleNotifications()" matTooltip="Notificaciones"  /> 
            <span class="badge" *ngIf="this.notificationService.navNotificationCount > 0">{{ this.notificationService.navNotificationCount }}</span>
            <app-nav-notifications class="notifications-container"></app-nav-notifications>
          </div> 
          
          <!-- alarmas 
          <div class="nav-notification" id="alarmsButtonNav">
            <button (click)="ToggleAlarms()" class="nav-button">
              <img class="nav-button-img" [src]="'icon_alarmas_blanco.svg' | findUrl"   />
            </button>
          </div> -->
          
          <div class="floating-button-container" (click)="ResetTutorials()" id="tutorialResetButton" matTooltip="Reiniciar Tutoriales">
            <img [src]="'reiniciar_tutoriales.svg' | findUrl" alt="">
          </div>
          
          <!-- boton de cerrar sesion -->
            <div *ngIf="isMapix" mat-button (click)="Logout()" class="floating-button-container"  id="logOutButton">
              <img [src]="'cerrar_sesion.svg' | findUrl" alt="">
            </div>
          </div>
          
          <!-- boton de expansion -->
          <div class="floating-button-container" (click)="toggleOptions()" matTooltip="Opciones" id="navToolsExpansion">
            <img [src]="'boton_lista_azul.svg' | findUrl" alt="" [style.width]="areOptionsExpanded ? '0' : 'inherit'" [style.opacity]="areOptionsExpanded ? '0' : '1'" [style.transform]="areOptionsExpanded ? 'rotate(0deg)' : 'rotate(180deg)'" style="transition:  200ms ease">
            <img [src]="'fecha_drop_menu.svg' | findUrl" alt="" [style.display]="areOptionsExpanded ? 'inherit' : 'none'" [style.opacity]="areOptionsExpanded ? '1' : '0'" [style.transform]="areOptionsExpanded ? 'rotate(0deg)' : 'rotate(180deg)'" style="transition:  200ms ease">
          </div>
        </div>
        
      </div>
      
    </mat-toolbar>
    
    <!-- contenedor del Side-bar -->
    <mat-sidenav-container
    [ngClass]="{'enlargeSideBar': this.isEnlargedSideBar}">
    
    <!-- contenido del side bar -->
    <mat-sidenav
    #snav
    [mode]="mobileQuery.matches ? 'over' : 'side'"
    [fixedInViewport]="true"
    [opened]="mobileQuery.matches"
    [disableClose]="mobileQuery.matches"
    class="menu-sidenav"
    id="sideBarNav">
    <!-- (mouseleave)="CloseSideBar($event)"
         (mouseenter)="StopCloseTimeout()"
    -->
    <!-- solo se crea cuando cargan las views -->
    <ng-container *ngIf="views && (sessionService.isExternalMap | async) == false">
      
      <mat-nav-list class="items-menu">
        
        <!-- <div class="nav-button-section"  [ngClass]="{'nav-button-section-enlarged': isEnlargedSideBar}">
          <button class="nav-button" *ngIf="mobileQuery.matches" mat-icon-button (click)="EnlargeOrCloseSideBar()" id="sideBarButtonNav">
            <img
            src="../../../../assets/img/navBar/btn_menu_azul.png"
            style="width: 1.5em;"
            />
          </button>
        </div> -->
        
        <!-- Sección superior con imagen de usuario y textos  ../../../../assets/img/navBar/icon_perfil.png  |  icon_usuario.svg-->
        <!-- <div class="navbar-option no-hover">
          <img src="../../../../assets/img/navBar/icon_perfil.png" alt="Usuario" class="profile-image"/>
          <div class="profile-text">
            <label *ngIf="isMapix" class="font-weight-bold">{{userName}}</label>
            <label>{{authService.roleItem$ | async}}</label>
            <label *ngIf="clientes.length < 2 && isMapix">{{ clienteDisplay }}</label>
            <div class="nav-text-client" *ngIf="clientes.length > 1 && !this.mobileQuery.matches">
              <mat-select class="form-control btn-clients"
              [placeholder]="clienteDisplay"
              [(value)]="clienteDisplay"
              (selectionChange)="onChangeClient($event)"
              [disabled]=" !isMapix ">
              <mat-option *ngFor="let client of clientes" [value]="client.idCustomer">
                {{ client.customerName }}
              </mat-option>
            </mat-select>
          </div>
        </div>
      </div>
      
      <mat-divider></mat-divider> -->
      
      <!-- Sección inferior con opciones del navbar -->
      <div class="menu-options">
        <!-- views dinamicas excepto la de config -->
        <!-- el filtro no funciona para verificar las views cargadas en el mapa, asi que se cabia a uno que se actualiza -->
         <!-- si se va a hacer la configuracion de las views a traves del rol del usuario, usar *ngIf="view.name | permissionFilter" y quitar *ngFor="let view of filteredViews"   -->
        <ng-container *ngFor="let view of views">
          <div
          id="{{view.name}}"
          *ngIf="view.name | permissionFilter"
          class="navbar-option" matTooltip="{{view.name}}"
          [disabled]="isBlocked"
          (click)="onClickMenuButton(view.uri)">
          <img [src]="view.icon | findUrl" alt="" />
          <span>{{ view.name }}</span>
        </div>
      </ng-container>
      <!-- solo view de config, para que aparezca al final -->
      <!-- <div
        id="Territorios" matTooltip="Rutas de zona"
        class="navbar-option"
        (click)="onClickMenuButton('territoriesMap')">
        <img [src]="'ruta_de_zona.svg' | findUrl" alt="" [ngClass]="{'dashboardAdminImHere': router.url === '/dashboardAdmin'}" />
        <span>Rutas de zona</span>
      </div> -->
      <div
        id="Configuración" matTooltip="Configuración"
        *ngIf="('Configuración' | permissionFilter)"
        class="navbar-option"
        (click)="onClickMenuButton('settingsAdmin')">
        <img [src]="'icon_configuration.png' | findUrl" alt="" [ngClass]="{'dashboardAdminImHere': router.url === '/dashboardAdmin'}" />
        <span>Configuración</span>
      </div>
  </div>
  
</mat-nav-list>

    </ng-container>
</mat-sidenav>
</mat-sidenav-container>

</div>
</div>
